import useQueryPermissions from './usergroup-use-query-permissions';


export const usergroupUseQuery = {
  getPermissions: useQueryPermissions
}